import { styled } from '@mui/material/styles';

export const ReleasesContentContainer = styled('div')`
    display: grid;
    grid-template-columns: 250px 1fr;
    gap: 20px;
`
